// IE 2026 11 02 / ODOO-349799 (group-levels) (заказ Игоря, скрин «Конфігурація» по чипу «Вид, Підсистема»): строки-группы wijmo (GroupRow
// сгруппированного списка) выглядели одинаково на всех уровнях и без элементов иерархии слева. Здесь — чистые расчёты: класс строки-группы
// по уровню (нулевой темнее и жирнее, глубже светлее; фон уровня только без своей заливки — правило / именованный стиль / hslGroup главнее)
// и геометрия направляющих слева по образцу дерева REPORT2 (AttrGrid formatItem_cells_break: оверлеи cell-frame-left / cell-divider-left).
// Выключатель fe.ux.gridGroupLevels (по умолчанию ВКЛ; false — поведение до правки: ни классов уровня, ни направляющих).

export const GROUP_LEVELS_FLAG = 'fe.ux.gridGroupLevels'

export function groupLevels_on(store) {
    try { return store?.setting?.(GROUP_LEVELS_FLAG, true) !== false } catch (e) { return true }
}

// Самый глубокий уровень со своим оформлением: level >= GROUP_LEVEL_CAP получает классы уровня GROUP_LEVEL_CAP
export const GROUP_LEVEL_CAP = 2

// Классы строки-группы уровня level: grp-level (маркер), grp-level-<n> (шрифт / отступ), grp-level-bg-<n> — фон уровня, ТОЛЬКО если у ячейки
// нет своей заливки (hasOwnClass: правило cssClass / именованный стиль с фоном / cell-background-* / inline-фон hslGroup).
// Некорректный уровень (undefined, отрицательный) считается нулевым.
// IE 2026 11 02 / ODOO-349799 (group-collapsed) (заказ Игоря, скрин «Конфігурація» по чипу «Вид, Підсистема»): СВЁРНУТАЯ группа — как свёрнутый узел дерева
// REPORT2 (AttrGrid formatItem_cells: `if (row.isCollapsed) {} else addClass(group-row-level-N)` — класс уровня с фоном и жирностью ставится только
// раскрытому узлу): ни фона уровня, ни жирности — только маркеры grp-level / grp-level-collapsed; иконка, отступ, направляющие и глиф остаются.
export function groupLevelClass(level, hasOwnClass, collapsed=false) {
    if (collapsed) return 'grp-level grp-level-collapsed'
    const lvl = Number.isInteger(level) && level >= 0 ? Math.min(level, GROUP_LEVEL_CAP) : 0
    const cls = ['grp-level', `grp-level-${lvl}`]
    if (!hasOwnClass) cls.push(`grp-level-bg-${lvl}`)
    return cls.join(' ')
}

// Направляющие слева у строки уровня level (лист под группами — maxGroupLevel + 1): по одной на каждого предка ilevel < level, как у дерева
// (цикл `for ilevel < row.level` в formatItem_cells_break). nextLevel — уровень следующей ВИДИМОЙ строки (-1 — строк дальше нет;
// лист — maxGroupLevel + 1); isLast — секция предка ilevel на этой строке закрывается (следующая строка не глубже предка) — у дерева
// `ilevel + 1 > rows[iNext].level`: в режиме рамки там рисуется угол и горизонталь.
export function groupGuides(level, nextLevel) {
    const lvl = Number.isInteger(level) && level > 0 ? level : 0
    const nl = Number.isInteger(nextLevel) ? nextLevel : -1
    const out = []
    for (let ilevel = 0; ilevel < lvl; ilevel++) out.push({ ilevel, isLast: nl <= ilevel })
    return out
}

// Отступ направляющей предка ilevel от левого края ячейки: wijmo сдвигает содержимое колонки дерева на cellPadLeft + level × treeIndent
// (updateCell: `treeIndent * level + _cellPadLeft`), глиф свёртки стоит ещё на glyphX правее (промер treeLines_frameGlyph) —
// линия предка идёт под его глифом
export function groupGuide_x(glyphX, cellPadLeft, treeIndent, ilevel) {
    const g = Number(glyphX) || 0, p = Number(cellPadLeft) || 0, t = Number(treeIndent) || 0
    return g + p + Math.max(0, Number(ilevel) || 0) * t
}

// IE 2026 11 03 / ODOO-350449 (group row pill) (замечание Игоря, три скрина: Segments «Порівняння» по чипу «Вид», «Конфігурація», REPORT2 «Ex-Delta» стр. 39):
// фон раскрытой строки-группы — закруглённая плашка на ВСЮ строку (все видимые ячейки), начинается с отступа своего уровня (у кнопки-треугольника),
// а не от левого края, и не заходит на линию родителя слева; у дерева REPORT2 фон уровня давал filter: brightness() ячейки — он темнил и белую маску
// слева (cell-delivery-left-0), отсюда «наезд» на линии предыдущей группы; плашка — отдельный элемент i.grp-pill-band под содержимым ячейки, маска не темнеет.
// Соединительная линия у треугольника — цвета треугольника (токен --grid-tree-line), без дуги, торчавшей над глифом («червячок с обрамлением»).
// Выключатель fe.ux.groupRowPill (по умолчанию ВКЛ; false — прежний вид: фон ячейками / filter, дуга и линии цвета --surface-border).
export const GROUP_ROW_PILL_FLAG = 'fe.ux.groupRowPill'
export const GROUP_PILL_CLASS = 'grp-pill'
export const GROUP_PILL_BAND = 'grp-pill-band'

export function groupRowPill_on(store) {
    try { return store?.setting?.(GROUP_ROW_PILL_FLAG, true) !== false } catch (e) { return true }
}

// Вид строки-группы по классам ячейки: 'list' — строка-группа wijmo сгруппированного списка с фоном уровня (grp-level-bg-N: своей заливки нет,
// группа раскрыта), 'tree' — раскрытый узел дерева REPORT2 (group-row-level-N без «Plain level»), null — не строка-группа (или без оформления уровня)
const RX_LIST = /(^|\s)grp-level-bg-\d+(\s|$)/
const RX_TREE = /(^|\s)group-row-level-\d+(\s|$)/
export function groupPill_kind(className, plainClass = 'row-plain-level') {
    const c = String(className || '')
    if (RX_LIST.test(c)) return 'list'
    if (RX_TREE.test(c) && !(plainClass && (' ' + c + ' ').includes(' ' + plainClass + ' '))) return 'tree'
    return null
}

// Левый край плашки в ячейке колонки дерева: у списка wijmo сдвигает содержимое padding-left (cellPadLeft + level × treeIndent) — плашка
// начинается за 2 px до кнопки-треугольника своего уровня (линия родителя — на treeIndent левее, под глифом родителя, остаётся снаружи);
// у дерева REPORT2 сама ячейка уже сдвинута на уровень (left += level × 12) — плашка от 1 px
export function groupPill_x(kind, paddingLeft) {
    if (kind === 'tree') return 1
    const p = Number.parseFloat(paddingLeft)
    return Math.max(1, (Number.isFinite(p) ? p : 0) - 2)
}

// Последняя видимая колонка (конец плашки — скругление справа); -1 — видимых нет
export function lastVisibleCol(columns) {
    if (!columns) return -1
    for (let i = (columns.length || 0) - 1; i >= 0; i--) { const c = columns[i]; if (c && (c.isVisible ?? c.visible) !== false) return i }
    return -1
}

// Плашка на ячейке: g = { start, end, x } или null (снять). Классы grp-pill / grp-pill-start / grp-pill-end и элемент i.grp-pill-band (последним ребёнком,
// под содержимым: z-index -1 в контексте ячейки); повторный вызов на той же ячейке не плодит элементы. true — плашка стоит
export function groupPill_paint(cell, g, doc = (typeof document !== 'undefined' ? document : null)) {
    if (!cell || !cell.classList) return false
    const cl = cell.classList
    let band = cell.querySelector(':scope > i.' + GROUP_PILL_BAND)
    if (!g) {
        if (cl.contains(GROUP_PILL_CLASS)) { cl.remove(GROUP_PILL_CLASS); cl.remove('grp-pill-start'); cl.remove('grp-pill-end') }
        if (band) band.remove()
        return false
    }
    cl.add(GROUP_PILL_CLASS)
    if (g.start) cl.add('grp-pill-start'); else cl.remove('grp-pill-start')
    if (g.end) cl.add('grp-pill-end'); else cl.remove('grp-pill-end')
    if (!band && doc) {
        band = doc.createElement('i')
        band.className = GROUP_PILL_BAND
        band.setAttribute('aria-hidden', 'true')
        cell.appendChild(band)
    }
    if (band) band.style.left = g.start ? `${Math.max(0, Number(g.x) || 0)}px` : ''
    return true
}
